var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVrDEtdcG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#F7F6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3334 23.7993V18.707C36.3334 18.1692 35.7999 17.7333 35.1424 17.7333C27.4157 17.7333 21.6207 17.7333 17.7574 17.7333C17.3795 17.7333 16.8128 17.7333 16.0571 17.7333C15.3996 17.7333 14.8667 18.1692 14.8667 18.707V36.3595C14.8667 36.8973 15.3996 37.3333 16.0571 37.3333H35.1424C35.7999 37.3333 36.3334 36.8973 36.3334 36.3595V31.2673V23.7993Z",
    stroke: "#32239B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8706 31.2673L43.0612 34.526C43.3977 34.7032 43.8 34.456 43.8 34.0718V20.9945C43.8 20.6112 43.3977 20.3635 43.0612 20.5407L36.8706 23.7994",
    stroke: "#32239B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6337 13.4336C11.0112 13.0561 11.506 12.8673 12.0007 12.8673C12.4955 12.8673 12.9903 13.0561 13.3678 13.4336L39.7665 39.8322C40.144 40.2097 40.3327 40.7045 40.3327 41.1993C40.3327 41.6941 40.144 42.1889 39.7665 42.5664C39.389 42.9439 38.8942 43.1326 38.3994 43.1326C37.9046 43.1326 37.4098 42.9439 37.0323 42.5664L10.6337 16.1677C10.2562 15.7902 10.0674 15.2954 10.0674 14.8007C10.0674 14.3059 10.2562 13.8111 10.6337 13.4336Z",
    fill: "#EE3D85",
    stroke: "#F7F6FB",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrDEtdcG);
export default __webpack_public_path__ + "static/media/VrDEtdcG.9af510acc59eecda320cc3b1827d0365.svg";
export { ForwardRef as ReactComponent };